import type { ReactNode } from "react";
import { Icon, type IconTypes } from "@foris/avocado-icons";
import cx from "classnames";
import styles from "./editableTableCell.module.scss";

interface EditableTableCellProps {
  children: ReactNode;
  disabled?: boolean;
  icon?: IconTypes;
  className?: string;
  onClick: () => void;
}

const EditableTableCell = ({
  children,
  disabled = false,
  icon = "edit",
  className,
  onClick,
}: EditableTableCellProps) => {
  const cellClassName = cx(styles.cell, className);
  if (disabled) return <span className={cellClassName}>{children}</span>;
  return (
    <button type="button" className={cellClassName} onClick={onClick}>
      <Icon className={styles.icon} name={icon} size="sm" color="neutral-70" />
      {children}
    </button>
  );
};

export default EditableTableCell;
